export default __webpack_public_path__ + "static/media/INROOM NODE.1fedd092.jpg";